<template>
  <ul :class="b(modifiers)">
    <li
      v-for="suggestion in suggestions"
      :key="suggestion.id"
      :class="b('list-item')"
      @click="$emit('suggestionClicked', suggestion)"
    >
      <e-icon-sprite
        v-if="icon"
        :class="b('icon')"
        :icon="icon"
      />
      <span :class="b('text')">
        {{ suggestion.value }}
      </span>
    </li>
  </ul>
</template>

<script>
  import eIconSprite from '@/elements/e-icon-sprite.vue';
  import themes from '@/mixins/themes.js';

  /**
   * Renders a list of search suggestions
   */
  export default {
    name: 'e-search-suggestions',
    components: {
      eIconSprite,
    },

    mixins: [themes],

    props: {
      /**
       * List of suggestions to be shown.
       */
      suggestions: {
        type: Array,
        default: () => [],
      },

      /**
       * Which icon to be shown on the left side of the text.
       */
      icon: {
        type: String,
        default: '',
      },
    },

    emits: ['suggestionClicked'],

    // data() {
    //   return {};
    // },

    computed: {
      /**
       * Defines state modifier classes.
       *
       * @returns  {Object}   BEM classes
       */
      modifiers() {
        const { theme, isVisible } = this;

        return {
          theme,
          isVisible,
        };
      },

      /**
       * Checks if the component is currently visible.
       *
       * @returns {Boolean}
       */
      isVisible() {
        return this.suggestions.length > 0;
      },
    },
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    // methods: {},
    // render() {},
  };
</script>

<style lang="scss">
  // @use 'sass:math';
  // @use '@/setup/scss/variables';
  // @use '@/setup/scss/mixins';
  @use '@/setup/scss/functions';
  // @use '@/setup/scss/extends' as *;

  .e-search-suggestions {
    $this: &;

    display: none;
    padding-left: 0;

    &--theme-sagemax {
      #{$this}__text {
        color: functions.get-theme-var('color-grayscale-1000');
      }

      #{$this}__icon {
        color: functions.get-theme-var('color-grayscale-1000');
      }

      #{$this}__list-item {
        &:hover {
          background: functions.get-theme-var('color-grayscale-200');
        }
      }
    }

    &--is-visible {
      display: block;
    }

    &__list-item {
      display: flex;
      flex: 1;
      padding: functions.rem(5px 25px);
      cursor: pointer;

      &:hover {
        background: functions.get-theme-var('color-grayscale-800');
      }
    }

    &__text {
      padding-left: functions.rem(10px);
      color: functions.get-theme-var('color-primary-1');
    }

    &__icon {
      min-width: functions.rem(20px);
      max-width: functions.rem(20px);
      min-height: functions.rem(20px);
      max-height: functions.rem(20px);
      color: functions.get-theme-var('color-primary-1');
    }
  }
</style>
